import moment from 'moment-timezone';
import Request from 'files/Request.js';
import Subscription from 'classes/Subscription.js';

class UserClass {

    active = true;
    address = null;
    age = null;
    avatar = null;
    created = null;
    dob = null;
    email_address = null;
    first_name = null;
    full_name = null;
    last_login = null;
    last_name = null;
    legal_agreements = null;
    level = null;
    location = null;
    onboarding = null;
    partnership_ids = null;
    passkey_configured = null;
    phone_number = null;
    referral_code = null;
    social_media = null;
    status = null;
    subscription = null;
    token = null;
    timezone = null;
    user_id = null;
    username = null;
    verified = null;
    
    constructor() {
        return this;
    }

	create = (props = {}) => {
        this.active = props.active;
        this.address = props.address;
        this.age = props.age;
        this.avatar = props.avatar;
        this.created = props.created && moment.utc(props.created).local();
        this.dob = props.dob;
        this.email_address = props.email_address;
        this.first_name = props.first_name;
        this.full_name = props.full_name;
        this.last_login = props.last_login && moment.utc(props.last_login).local();
        this.last_name = props.last_name;
        this.legal_agreements = props.legal_agreements;
        this.level = props.level;
        this.location = props.location;
        this.onboarding = props.onboarding;
        this.partnership_ids = props.partnership_ids || [];
        this.passkey_configured = props.passkey_configured;
        this.phone_number = props.phone_number;
        this.referral_code = props.referral_code;
        this.social_media = props.social_media;
        this.status = props.status;
        this.subscription = props.subscription && Subscription.create(props.subscription);
        this.timezone = props.timezone;
        this.token = props.token;
        this.user_id = props.user_id;
        this.username = props.username;
        this.verified = props.verified;
        return this;
	}
}

export const fetchUser = async (utils, userID) => {
    return new Promise(async (resolve, reject) => {
        try {
            let { user } = await Request.get(utils, '/users/', {
                type: 'details',
                user_id: userID
            });
            resolve(new UserClass().create(user));
        } catch(e){
            reject(e);
        }
    });
}

const levels = {
    system_admin: 1,
    admin: 1000,
    sales_ops: 9000,
    customer: 9999
}

const levelToText = code => {
    switch(code) {
        case levels.system_admin:
        return 'System Administrator';

        case levels.admin:
        return 'Administrator';

        case levels.sales_ops:
        return 'Sales Operative';

        case levels.customer:
        return 'Customer';

        default:
        return 'Unknown account type';
    }
}

const statusCodes = {
    secured: 1,
    failed_lifecheck_verification: 100,
    emergency_override_confirmed: 200,
    awaiting_trusted_contact: 300,
    instructions_execution_granted: 400,
    emergency_trigger_executed: 450,
    confirmed_deceased: 500
}

export default {
    create: props => new UserClass().create(props),
    get: fetchUser,
    levels: {
        get: () => levels,
        toText: levelToText
    },
    new: () => new UserClass(),
    status: {
        get: () => statusCodes
    }
}
